import { render, staticRenderFns } from "./CarouselWithAsideInfoBlock.vue?vue&type=template&id=76682921"
import script from "./CarouselWithAsideInfoBlock.vue?vue&type=script&lang=js"
export * from "./CarouselWithAsideInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports